/* AR Showroom — collection filters and product page. Uses helpers from ar-core.js (window.ARX). */
(() => {
  'use strict';
  const X = window.ARX;
  if (!X) return;
  const { $, $$, debounce, parse, store, url, toast, openDialog, reduceMotion, S, AR } = X;
  const syncWish = () => X.syncAll && X.syncAll();
  const syncCompare = () => {};
  const pp = $('[data-pp]');
  /* ---------------- Recently viewed + recommendations ---------------- */
  const RKEY = 'ar:recent';
  if (pp) {
    const h = pp.dataset.handle;
    store.set(RKEY, [h, ...store.get(RKEY, []).filter((x) => x !== h)].slice(0, 12));
  }
  $$('[data-recent]').forEach(async (sec) => {
    const ex = sec.dataset.exclude;
    const limit = parseInt(sec.dataset.limit || '4', 10);
    const list = store.get(RKEY, []).filter((x) => x !== ex).slice(0, limit);
    if (!list.length) return;
    const htmls = await Promise.all(list.map(async (h) => {
      try {
        const res = await fetch(url(`/products/${encodeURIComponent(h)}?section_id=ar-card`));
        if (!res.ok) return '';
        const card = $('[data-card]', parse(await res.text()));
        return card ? `<li>${card.outerHTML}</li>` : '';
      } catch (e) { return ''; }
    }));
    const ul = $('[data-recent-list]', sec);
    ul.innerHTML = htmls.join('');
    if (ul.children.length) { sec.hidden = false; syncWish(); syncCompare(); }
  });
  $$('[data-recs]').forEach(async (sec) => {
    if (sec.children.length) return;
    try {
      const res = await fetch(sec.dataset.url);
      const doc = parse(await res.text());
      const src = $('[data-recs]', doc);
      if (src && src.innerHTML.trim()) { sec.innerHTML = src.innerHTML; syncWish(); syncCompare(); }
    } catch (e) { /* recommendations are optional */ }
  });

  /* ---------------- Collection + search filters ---------------- */
  const coll = $('[data-coll-section]');
  if (coll) {
    const sectionId = coll.dataset.sectionId;
    let ctrl;
    const render = async (href, push = true) => {
      const u = new URL(href, window.location.origin);
      u.searchParams.delete('section_id');
      const fetchUrl = new URL(u); fetchUrl.searchParams.set('section_id', sectionId);
      if (ctrl) ctrl.abort(); ctrl = new AbortController();
      coll.classList.add('is-loading');
      const openIds = $$('details.facet', coll).filter((d) => d.open).map((d) => d.id);
      const expandedIds = $$('.is-expanded', coll).map((l) => l.id).filter(Boolean);
      const act = document.activeElement;
      const focusId = act && coll.contains(act) ? act.id : '';
      const hadFocus = !!(act && coll.contains(act));
      try {
        const res = await fetch(fetchUrl, { signal: ctrl.signal });
        const doc = parse(await res.text());
        ['[data-results]', '[data-facets-desktop]', '[data-facets-mobile]'].forEach((sel) => {
          const a = $(sel, coll); const b = $(sel, doc); if (a && b) a.innerHTML = b.innerHTML;
        });
        const sc = $('[data-show-count]', doc); const tc = $('[data-show-count]', coll); if (sc && tc) tc.textContent = sc.textContent;
        $$('details.facet', coll).forEach((d) => { if (openIds.includes(d.id)) d.open = true; });
        expandedIds.forEach((id) => { const l = document.getElementById(id); if (!l) return; l.classList.add('is-expanded'); const b = $(`[aria-controls="${id}"]`, coll); if (b) { b.setAttribute('aria-expanded', 'true'); b.textContent = 'Show fewer'; } });
        if (hadFocus) {
          const back = focusId && document.getElementById(focusId);
          const status = $('[data-count-status]', coll);
          if (back) back.focus({ preventScroll: true });
          else if (status) { status.tabIndex = -1; status.focus({ preventScroll: true }); }
        }
        if (push) history.pushState({ ar: 1 }, '', u.pathname + u.search);
        syncWish(); syncCompare();
      } catch (e) { if (e.name !== 'AbortError') window.location.href = u.pathname + u.search; }
      finally { coll.classList.remove('is-loading'); }
    };
    const fromForm = (form) => {
      const params = new URLSearchParams();
      new FormData(form).forEach((v, k) => { if (String(v).trim() !== '') params.append(k, v); });
      const sort = $('[data-sort]', coll); if (sort) params.set('sort_by', sort.value);
      return `${form.getAttribute('action')}?${params.toString()}`;
    };
    const debounced = debounce((f) => render(fromForm(f)), 450);
    coll.addEventListener('change', (e) => {
      if (e.target.matches('[data-sort]')) {
        const f = $('[data-facets-form]', coll);
        if (f) { render(fromForm(f)); } else { const u = new URL(window.location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); render(u.toString()); }
        return;
      }
      const form = e.target.closest('[data-facets-form]');
      if (!form) return;
      if (e.target.matches('[data-price-input]')) debounced(form); else render(fromForm(form));
    });
    coll.addEventListener('input', (e) => { if (e.target.matches('[data-price-input]')) debounced(e.target.closest('form')); });
    coll.addEventListener('submit', (e) => { const f = e.target.closest('[data-facets-form]'); if (f) { e.preventDefault(); render(fromForm(f)); } });
    coll.addEventListener('click', (e) => {
      const a = e.target.closest('a[data-facet-link]');
      if (a) { e.preventDefault(); const isPage = a.closest('.pager'); render(a.href).then(() => { if (isPage) $('[data-results]', coll).scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' }); }); return; }
      const more = e.target.closest('[data-more]');
      if (more) { const l = document.getElementById(more.getAttribute('aria-controls')); const open = !l.classList.contains('is-expanded'); l.classList.toggle('is-expanded', open); more.setAttribute('aria-expanded', String(open)); more.textContent = open ? 'Show fewer' : more.textContent.replace('Show fewer', 'Show all'); }
    });
    window.addEventListener('popstate', () => render(window.location.href, false));
  }

  /* ---------------- Product page ---------------- */
  if (pp) {
    const sectionId = pp.dataset.section;
    const form = $('[data-pp-form]', pp);
    const variants = (() => { try { return JSON.parse($('[data-pp-variants]').textContent); } catch (e) { return []; } })();
    const track = $('[data-track]', pp);
    const slides = track ? $$('[data-slide]', track) : [];
    const thumbs = $$('[data-thumb]', pp);
    const counter = $('[data-counter]', pp);
    let index = 0;
    const go = (i, smooth = true) => {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
    };
    if (track) {
      const onScroll = () => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i === index && counter && counter.textContent == i + 1) return;
        index = i;
        if (counter) counter.textContent = i + 1;
        thumbs.forEach((t, k) => t.setAttribute('aria-current', String(k === i)));
        const at = thumbs[i]; if (at) at.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      };
      track.addEventListener('scroll', debounce(onScroll, 60), { passive: true });
      track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); } });
      thumbs.forEach((t) => t.addEventListener('click', () => go(parseInt(t.dataset.thumb, 10))));
      const prev = $('[data-prev]', pp); const next = $('[data-next]', pp);
      if (prev) prev.addEventListener('click', () => go(index - 1));
      if (next) next.addEventListener('click', () => go(index + 1));
    }
    const lb = $('#lightbox');
    pp.addEventListener('click', (e) => {
      const z = e.target.closest('[data-zoom]');
      if (!z || !lb) return;
      lb.showModal(); document.documentElement.classList.add('no-scroll');
      const t = $('[data-lb-track]', lb); const fig = t.children[parseInt(z.dataset.zoom, 10)];
      if (fig) t.scrollLeft = fig.offsetLeft;
    });

    /* quantity */
    pp.addEventListener('click', (e) => {
      const b = e.target.closest('[data-qty-step]');
      if (!b) return;
      const input = $('input', b.closest('[data-qty]'));
      const max = input.max ? parseInt(input.max, 10) : Infinity;
      input.value = Math.min(max, Math.max(1, parseInt(input.value || '1', 10) + parseInt(b.dataset.qtyStep, 10)));
    });

    /* variants */
    const selected = () => $$('fieldset[data-option]', pp).map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
    if (form) form.addEventListener('change', async (e) => {
      if (!e.target.matches('[data-opt-input]')) return;
      const fs = e.target.closest('fieldset'); const lab = $('[data-opt-label]', fs); if (lab) lab.textContent = e.target.value;
      const opts = selected();
      const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
      const idInput = $('[data-pp-id]', form);
      const buyBtn = $('[data-main-atc]', pp);
      if (!v) {
        if (buyBtn) { buyBtn.disabled = true; buyBtn.textContent = 'Unavailable'; buyBtn.removeAttribute('data-atc'); }
        const av = $('[data-pp-avail]', pp); if (av) av.innerHTML = '<p class="avail avail--out">This combination is not available. Choose another option.</p>';
        return;
      }
      idInput.value = v.id;
      const u = new URL(window.location.href); u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u.pathname + u.search);
      if (v.featured_media) { const i = slides.findIndex((s) => s.dataset.mediaId == v.featured_media.id); if (i > -1) go(i); }
      const qty = $('#pp-qty', pp) ? $('#pp-qty', pp).value : '1';
      try {
        const res = await fetch(`${pp.dataset.url}?variant=${v.id}&section_id=${sectionId}`);
        const doc = parse(await res.text());
        ['[data-pp-price]', '[data-pp-avail]', '[data-pp-buy]', '[data-pp-pickup]', '[data-sticky-price]'].forEach((sel) => {
          const a = $(sel); const b = $(sel, doc); if (a && b) a.innerHTML = b.innerHTML;
        });
        $$('.pill', doc).forEach((p, i) => { const mine = $$('.pill', pp)[i]; if (mine) mine.classList.toggle('pill--na', p.classList.contains('pill--na')); });
        const sAtc = $('[data-sticky-atc]'); const nAtc = $('[data-sticky-atc]', doc);
        if (sAtc && nAtc) { sAtc.disabled = nAtc.disabled; sAtc.textContent = nAtc.textContent; sAtc.className = nAtc.className; }
        const sv = $('[data-sticky-variant]'); if (sv) sv.textContent = v.title;
        const q = $('#pp-qty', pp); if (q) q.value = Math.min(qty, q.max ? parseInt(q.max, 10) : Infinity) || 1;
        if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
      } catch (err) { window.location.href = u.toString(); }
    });

    /* sticky purchase bar */
    const bar = $('[data-sticky-buy]');
    const mq = window.matchMedia('(max-width: 999px)');
    if (bar) {
      const setVisible = (on) => {
        on = on && mq.matches;
        bar.classList.toggle('is-visible', on);
        bar.setAttribute('aria-hidden', String(!on));
        const b = $('[data-sticky-atc]', bar); if (b) b.tabIndex = on ? 0 : -1;
        document.body.classList.toggle('has-sticky-buy', on);
      };
      /* Shown once the main buy buttons have scrolled above the viewport. A scroll check (one per frame)
         is used instead of an observer so fast or programmatic jumps past the buttons are not missed. */
      const target = () => $('[data-pp-buy]', pp);
      let ticking = false;
      const check = () => { ticking = false; const t = target(); if (t) setVisible(t.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
      window.addEventListener('resize', () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
      check();
      bar.addEventListener('click', (e) => {
        if (!e.target.closest('[data-sticky-atc]') || e.target.disabled) return;
        if (form.requestSubmit) form.requestSubmit($('[data-main-atc]', form)); else $('[data-main-atc]', form).click();
      });
      mq.addEventListener('change', check);
    }

    /* wrap wide tables in the description */
    $$('[data-prose] table').forEach((t) => { if (t.parentElement.classList.contains('table-wrap')) return; const w = document.createElement('div'); w.className = 'table-wrap'; t.replaceWith(w); w.appendChild(t); });
  }

})();